module.exports = __webpack_public_path__ + "img/2.c11e84dc.jpeg";